export enum KorrespondenzVorlageLinkRel {
	KORRESPONDENZ_VORLAGE_FILE = 'korrespondenzVorlageFile',
	UPLOAD_FILE = 'uploadNewFile',
	DELETE = 'delete',
	VORLAGE = 'vorlage',
}
